import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, o = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "M39.311 25.217A20.02 20.02 0 0 0 40 20c0-1.805-.24-3.554-.689-5.217L18.261.076A19.898 19.898 0 0 0 7.826 4.132L.69 14.782A20.022 20.022 0 0 0 0 20c0 1.795.238 3.534.681 5.189l7.145 10.679a19.898 19.898 0 0 0 10.435 4.056l21.05-14.707Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#0052B4",
  d: "M.689 25.217a20.017 20.017 0 0 0 7.137 10.65v-10.65H.69ZM18.26 39.924c.574.05 1.154.076 1.74.076 9.24 0 17.016-6.267 19.311-14.783h-21.05v14.707Zm21.051-25.141C37.016 6.267 29.241 0 20 0c-.586 0-1.166.027-1.74.076v14.707h21.051ZM7.826 4.132A20.017 20.017 0 0 0 .69 14.782h7.137V4.133Z"
}, null, -1), a = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "M39.83 17.391H15.653V.475c-1.848.41-3.6 1.075-5.217 1.957v14.96H.169a20.173 20.173 0 0 0 0 5.217h10.266v14.96a19.86 19.86 0 0 0 5.217 1.956V22.609h24.179a20.196 20.196 0 0 0 0-5.218Z"
}, null, -1), s = [
  o,
  c,
  a
];
function h(d, i) {
  return e(), l("svg", n, [...s]);
}
const _ = { render: h };
export {
  _ as default,
  h as render
};
